module.exports = __webpack_public_path__ + "whiteyogasymbol.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/whiteyogasymbol.png
// module id = 910
// module chunks = 0